import React from "react";
import CsvTable from "./components/CsvTable";
import "./CentralitiesTable.scss";

const CentralitiesTable = () => {
  return (
    <div className="analysis-members analysis-members-bg-white">
      <div className="analysis-members-container">
        <CsvTable />
      </div>
    </div>
  );
};

export default CentralitiesTable;
